import { render, staticRenderFns } from "./OnlineExhibitionDetail.vue?vue&type=template&id=7d907bdd&scoped=true"
import script from "./OnlineExhibitionDetail.vue?vue&type=script&lang=js"
export * from "./OnlineExhibitionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d907bdd",
  null
  
)

export default component.exports